import React, { useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import '../../transactions.scss';
import { ENABLE_MFA } from "../../../../../../actions/accountsActions";
import { getUseronboardingInfo } from "../../../../../../actions/loginActions";
import { useDispatch } from "react-redux";
import { TOAST_SUCCESS } from "../../../../../../utils";

function MfaAuthenticator({ userData }){
    const LinkRef = useRef();
    const [copyTooltip, setcopyTooltip] = useState(false);
    const [mfaStatus, setMfaStatus] = useState(userData?.is_mfa_enable || 0);
    const [mfaCode, setMfaCode] = useState(userData?.mfa_secret || '');
    const [mfaImg, setMfaImg] = useState(userData?.mfa_image || '');
    const [otp, setOtp] = useState('');
    const dispatch = useDispatch();

    const copyCode = () => {
        navigator.clipboard.writeText(LinkRef.current.value).then(() => { setcopyTooltip(true); setTimeout(() => setcopyTooltip(false), 2000);
        }).catch(() => { setcopyTooltip(false); });
    };

    const getMfaData = (is_mfa_enable, reload_qr) => {
        ENABLE_MFA({is_mfa_enable, reload_qr}).then((res) => {
            const {responseData, responseCode } = res?.data;
            if (responseCode === 200) {
                setMfaStatus(responseData.is_mfa_enable);
                setMfaCode(responseData.mfa_secret);
                setMfaImg(responseData.mfa_image);
                dispatch(getUseronboardingInfo());
                if(reload_qr) TOAST_SUCCESS('MFA reset successfully');
            }
        });
    }

    return(
        <Card className="card-custom p-4">
            <div className="bg-light p-lg-5 p-3 rounded border d-flex align-items-center justify-content-between">
                <div className="">
                    <h4>Enhance your account’s security by enabling 2FA.</h4>
                    <p className="m-0">It helps prevent unauthorized access even if your password is compromised. </p>
                </div>
                <div className="">
                    <span className="switch custom-toggle ms-2">
                    <label className="form-check p-0 d-flex align-items-center m-0">
                        <input type="checkbox" checked={mfaStatus} className="form-check-input me-2" onChange={(e) => {getMfaData(Number(e.target.checked), 0)}}/><span></span>
                    </label>
                    </span>
                </div>
            </div>
            {mfaStatus ? (
            <div className="mt-lg-4 mt-3">
                <h4 className="mb-3">Set Up Your Authenticator App </h4>
                <div className="mb-3">
                    {/* <h5>Scan QR Code</h5> */}
                    <p className="m-0">Use an authenticator app (like Google Authenticator, Microsoft Authenticator, or Authy) to scan this QR code. Once scanned, your app will generate a 6-digit code to use during login.</p>
                </div>
                <div className="mb-3">
                    {mfaImg ? <img src={mfaImg} alt="qr-code" className="img-fluid border rounded" width={'200'}/> :''}
                </div>
                <div className="">
                    <h6>Backup Key</h6>
                    <p className="m-0">Use this backup key if you're unable to access your authenticator app or if the generated 2FA code doesn’t work</p>
                    <div className="copy-qr-link mt-4">
                        <div className="d-flex position-relative mb-2" onClick={(e) => { copyCode(1) }} style={{ maxWidth: '480px' }}>
                            <input readOnly="readOnly" type="text" className="form-control" value={mfaCode} ref={LinkRef} />
                            <span id="copy-success-alert" style={{ display: copyTooltip ? 'block' : 'none' }}>Copied to clipboard</span>
                            <FontAwesomeIcon type={'regular'} icon={'copy'} iconClass={'text-gray-500 cursor-pointer d-sm-block d-none'}/>
                        </div>
                        <p>💾 Important: Save this key in a safe place on your computer or device..</p>
                        <Button variant="secondary" className="d-inline-block px-4 rounded border mt-3 text-gray fw-bold" onClick={() => getMfaData(mfaStatus, 1)}>Reset QR and Key</Button>
                    </div>
                </div>
            </div>
            ) : null}
        </Card>
    )
}

export default MfaAuthenticator;